import { createContext, useState, ReactNode, useEffect } from 'react'
import { api } from '../services/api'

interface UserProviderProps {
    children: ReactNode;
}

interface UserContextProps {
    userStatus: boolean;
    //validateUser: () => void;
}

export const UserContext = createContext<UserContextProps>({} as UserContextProps)

export function UserProvider({ children }: UserProviderProps) {
    const [userStatus, setUserStatus] = useState(false)
    const user = JSON.parse(localStorage.getItem('userData') || '{}')

    useEffect(() => {
        async function validateToken() {
            let result = await api.post('/validateToken', user)            
            setUserStatus(result.data)
        }

        validateToken()
    }, [user])

    return (
        <UserContext.Provider
            value={{ userStatus }}
        >
            {children}
        </UserContext.Provider>
    );
}